import ColorHash from 'color-hash'; // eslint-disable-line import/no-extraneous-dependencies

const HASH = new ColorHash({
  hue: { min: 50, max: 355 },
  saturation: 0.55,
  lightness: [0.4, 0.75, 0.5],
});

export const colorHash = text => HASH.hex((text || '').split('').reverse().join(''));
